<template>
  <v-menu open-on-click offset-y bottom :allow-overflow="false" :nudge-top="nudge" transition="scroll-y-reverse-transition">
    <template v-slot:activator="{ on: menu }">
    <v-tooltip top>
      <template v-slot:activator="{ on: tooltip }">
      <v-btn text v-on="{ ...tooltip, ...menu }"
             color="white">
        <v-icon>language</v-icon> <span class="ml-2">{{lang}}</span>
      </v-btn>
      </template>
      <span>{{$tf('Language')}}</span>
    </v-tooltip>
  </template>
    <v-list class="lang" ref="langMenu" v-observe-visibility="visible=>hideLangs(visible)" >
      <v-list-group :value="espActive" v-bind:key="'esp'">
        <v-list-item class="text-left pl-10" slot="activator" @click.stop.prevent="espActive=!espActive" no-action>
          <v-list-item-content style="width: 100px" :ripple="false">
            <v-list-item-title>Español</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon @click.stop.prevent="espActive=!espActive" >{{espActive ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</v-icon>
          </v-list-item-action>
        </v-list-item>
        <v-list-item v-for="item in esp" :key="item.code" class="text-left pl-10"  @click="pickLocale(item.code)">
          <v-list-item-avatar class="ml-0 mr-2" size="20"><img :src=item.icon :alt="item.code+'-flag'"></v-list-item-avatar>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list-group>

      <v-list-item class="text-left pl-10" @click="pickLocale('eu-ES')">
        <v-list-item-content>
          <v-list-item-title>Euskara</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-group :value="catActive" v-bind:key="'cat'" >
        <v-list-item class="text-left pl-10"  slot="activator" @click.stop.prevent="catActive=!catActive" no-action>
          <v-list-item-content style="width: 100px" :ripple="false">
            <v-list-item-title>Català</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon @click.stop.prevent="catActive=!catActive" >{{catActive ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</v-icon>
          </v-list-item-action>
        </v-list-item>
        <v-list-item v-for="item in cat" :key="item.code" class="text-left pl-10"  @click="pickLocale(item.code)">
          <v-list-item-avatar class="ml-0 mr-2" size="20"><img :src=item.icon :alt="item.code+'-flag'"></v-list-item-avatar>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list-group>

      <v-list-item class="text-left pl-10" @click="pickLocale('en-US')">
        <v-list-item-content>
          <v-list-item-title>English</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item class="text-left pl-10" @click="pickLocale('it-IT')">
        <v-list-item-content>
          <v-list-item-title>Italiano</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item class="text-left pl-10" @click="pickLocale('fr-FR')">
        <v-list-item-content>
          <v-list-item-title>Français</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import locale, { markExplicitLocale } from '../../mixins/locale'
import locales from '../../locales/index.js'
import { ObserveVisibility } from 'vue-observe-visibility'
export default {
  name: 'LanguagePicker',
  mixins: [locale],
  computed: {
    nudge () {
      if (this.espActive) {
        return 410
      }
      if (this.catActive) {
        return 290
      }
      return 170
    },
    lang () {
      this.$log.log('language:', this.$i18n.locale)
      let lang = locales.find(lang => lang.code === this.$i18n.locale)
      return lang ? lang.name : 'English'
    }
  },
  data () {
    return {
      espActive: false,
      catActive: false,
      esp: [
        { title: 'Argentina', code: 'es-AR', icon: '/flags/1x1/ar.svg' },
        { title: 'Chile', code: 'es-CL', icon: '/flags/1x1/cl.svg' },
        { title: 'Colombia', code: 'es-CO', icon: '/flags/1x1/co.svg' },
        { title: 'España', code: 'es-ES', icon: '/flags/1x1/es.svg' },
        { title: 'México', code: 'es-MX', icon: '/flags/1x1/mx.svg' }],
      cat: [
        { title: 'Andorra', code: 'ca-AD', icon: '/flags/1x1/ad.svg' },
        { title: 'Català', code: 'ca-ES', icon: '/flags/1x1/cat.svg' }]
    }
  },
  watch: {
    catActive (val) {
      if (val) {
        this.espActive = false
      }
    },
    espActive (val) {
      if (val) {
        this.catActive = false
      }
    }
  },
  methods: {
    pickLocale (code) {
      markExplicitLocale(code)
      this.setLocale(code)
    },
    hideLangs (visible) {
      if (!visible) {
        this.espActive = false
        this.catActive = false
      }
    }
  },
  directives: {
    'observe-visibility': ObserveVisibility
  }
}
</script>

<style>

  .lang .v-list-group__header{
    padding-left: 0;
    padding-right: 0;
  }
  .lang .v-list-group__header__append-icon{
    display: none;
  }
  .menu__content{
    margin-top: 25px;
    width: fit-content;
  }
</style>
